/* eslint-disable react/no-deprecated */

import React, { Component } from "react"
import { translate } from "react-i18next"
import compose from "ramda/src/compose"
import { connect } from "react-redux"
import { bool, func, array, string, object } from "prop-types"
import Modal from "shared/components/ModernModal"
import { Button, EmptyState } from "shared/components"
import IconEmptyState from "assets/svg/solicitacoes.svg"
import TechnicianMap from "./components/TechnicianMap"
import styles from "./styles.css"
import Icon from "../../assets/svg/acompanhar-tecnico-branco.svg"
import {
  closeTechnicianModal,
  getTechnicians
} from "../../services/state/actions"
import Typograph from "../Typograph/index"

class TechnicianModal extends Component {
  componentWillReceiveProps(nextProps) {
    const { activityIds, getTechnicians } = this.props

    if (!this.technicianInterval && activityIds.length) {
      clearInterval(this.technicianInterval)
      this.technicianInterval = setInterval(() => {
        if (!activityIds.length)
          // eslint-disable-next-line no-void
          return void clearInterval(this.technicianInterval)
        getTechnicians(activityIds)
      }, 6000)
    }
  }

  componentWillUnmount() {
    clearInterval(this.technicianInterval)
  }

  closeModal = () => {
    const { onClose, closeTechnicianModal } = this.props
    clearInterval(this.technicianInterval)
    return onClose ? onClose() : closeTechnicianModal()
  }

  render() {
    const {
      t,
      isOpen,
      isModalOpen,
      clientLocale,
      technicians,
      activityIds,
      emptyCoordinates
    } = this.props
    return (
      <Modal
        icon={Icon}
        isOpen={isOpen || isModalOpen}
        onClose={this.closeModal}
        onConfirm={this.closeModal}
        confirmButtonText="Fechar"
        removeButton
        customModalClass={styles.modalSize}
      >
        <Typograph
          htmlTag="h4"
          size="medium"
          color="outer_space"
          weight="bold"
          classNames={styles.title}
        >
          {t("MSG_0230")}
        </Typograph>
        <div className={styles.techniciansContainer}>
          <div className={styles.mapContainer}>
            {activityIds.length === 1 && emptyCoordinates ? (
              <EmptyState
                icon={IconEmptyState}
                title={t("MSG_0331")}
                msg={t("EMPTY_TECHNICIAN")}
              />
            ) : (
              <TechnicianMap
                clientLocale={clientLocale}
                techniciansLocale={technicians}
                apiKey="AIzaSyCmxBDpB8r3BoBOepuWxBsAAHqYr4qhYU4"
              />
            )}
          </div>

          <div className={styles.actions}>
            <Button relevance="normal" callToAction onClick={this.closeModal}>
              {t("MSG_0111")}
            </Button>
          </div>
        </div>
      </Modal>
    )
  }
}

TechnicianModal.propTypes = {
  isOpen: bool,
  onClose: func,
  activityIds: array,
  productAddress: string,
  getTechnicians: func,
  closeTechnicianModal: func,
  isModalOpen: bool,
  clientLocale: object,
  technicians: array,
  emptyCoordinates: bool,
  t: func
}

/*
  As cores não vem no serviço, precisam ser mapeadas a parte
  por ordem dos técnicos.
  PS: A chance de vir mais que um técnico é MUITO baixa.
*/
TechnicianModal.defaultProps = {
  isOpen: false,
  technicians: [
    /* {
    id: '09948924-5',
    color: '#1e333b',
    lat: 41.148330,
    lng: -8.606321,
  }, {
    id: '09948924-5',
    color: '#e78506',
    lat: 41.153587,
    lng: -8.610408,
  }, {
    id: '09948924-5',
    color: '#7d17c4',
    lat: 41.150008,
    lng: -8.613344,
  } */
  ],
  activityIds: [
    /* '1153', '1153','1153' */
  ],
  // productAddress: 'rua%20fernandes%20tomas%20porto',
  productAddress: ""
}

const mapStateToProps = ({ technician }) => ({
  isModalOpen: technician.isModalOpen,
  clientLocale: technician.clientLocale,
  technicians: technician.technicians,
  emptyCoordinates: technician.emptyCoordinates
})

const enhance = compose(
  translate(),
  connect(mapStateToProps, { closeTechnicianModal, getTechnicians })
)

export default enhance(TechnicianModal)



// WEBPACK FOOTER //
// ./src/components/TechnicianModal/index.js